// extracted by mini-css-extract-plugin
export var Copyright = "index-module--Copyright--+nA11";
export var Link = "index-module--Link--5YN59";
export var SocialIcon = "index-module--SocialIcon--WklLD";